import React, { useEffect, useState } from "react";

const Complaints = () => {
  const [monthend, setMonthEnd] = useState(null);
  const [monthly, setMonthly] = useState(null);
  const [annual, setAnnual] = useState(null);

  useEffect(() => {
    // Fetch all JSON files
    Promise.all([
      fetch("/data/monthend.json").then((res) => res.json()),
      fetch("/data/monthdisposal.json").then((res) => res.json()),
      fetch("/data/annualdisposal.json").then((res) => res.json()),
    ])
      .then(([monthEndData, monthlyData, annualData]) => {
        setMonthEnd(monthEndData);
        setMonthly(monthlyData);
        setAnnual(annualData);
      })
      .catch((error) => console.error("Error fetching JSON:", error));
  }, []);

  if (!monthend || !monthly || !annual) {
    return (
      <p className="text-center my-10 text-lg font-semibold">Loading data...</p>
    );
  }

  return (
    <section className="text-center my-10 px-4">
      {/* Month-end data */}
      <h4 className="text-xl font-semibold mb-4">
        Data for the month ending - {monthend.month_ending}
      </h4>
      <div className="overflow-x-auto">
        <table className="w-full max-w-7xl mx-auto border border-gray-300 rounded-lg shadow-md">
          <thead className="bg-gray-200">
            <tr className="text-sm md:text-base">
              <th className="p-2 border">Sr. No.</th>
              <th className="p-2 border">Received from</th>
              <th className="p-2 border">Pending last month</th>
              <th className="p-2 border">Received</th>
              <th className="p-2 border">Resolved</th>
              <th className="p-2 border">Total Pending</th>
              <th className="p-2 border">Pending &gt; 3 months</th>
              <th className="p-2 border">Avg. Resolution (days)</th>
            </tr>
          </thead>
          <tbody>
            {monthend.data.map((item) => (
              <tr
                key={item.Sr_No}
                className="text-sm md:text-base even:bg-gray-100"
              >
                <td className="p-2 border">{item.Sr_No}</td>
                <td className="p-2 border">{item.Received_from}</td>
                <td className="p-2 border">{item.Pending_last_month}</td>
                <td className="p-2 border">{item.Received}</td>
                <td className="p-2 border">{item.Resolved}</td>
                <td className="p-2 border">{item.Total_Pending}</td>
                <td className="p-2 border">
                  {item.Pending_complaints_over_3_months}
                </td>
                <td className="p-2 border">
                  {item.Average_Resolution_time_days}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Monthly disposal trend */}
      <h4 className="mt-10 text-xl font-semibold">
        Trend of Monthly Disposal of Complaints
      </h4>
      <div className="overflow-x-auto">
        <table className="w-full max-w-7xl mx-auto border border-gray-300 rounded-lg shadow-md">
          <thead className="bg-gray-200">
            <tr className="text-sm md:text-base">
              <th className="p-2 border">Sr. No.</th>
              <th className="p-2 border">Month</th>
              <th className="p-2 border">Carried Forward</th>
              <th className="p-2 border">Received</th>
              <th className="p-2 border">Resolved</th>
              <th className="p-2 border">Pending</th>
            </tr>
          </thead>
          <tbody>
            {monthly.data.map((item, index) => (
              <tr key={index} className="text-sm md:text-base even:bg-gray-100">
                <td className="p-2 border">{index + 1}</td>
                <td className="p-2 border">{item.Month}</td>
                <td className="p-2 border">{item.Carried_forward}</td>
                <td className="p-2 border">{item.Received}</td>
                <td className="p-2 border">{item.Resolved}</td>
                <td className="p-2 border">{item.Pending}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Annual disposal trend */}
      <h4 className="mt-10 text-xl font-semibold">
        Trend of Annual Disposal of Complaints
      </h4>
      <div className="overflow-x-auto">
        <table className="w-full max-w-7xl mx-auto border border-gray-300 rounded-lg shadow-md">
          <thead className="bg-gray-200">
            <tr className="text-sm md:text-base">
              <th className="p-2 border">Year</th>
              <th className="p-2 border">Carried Forward</th>
              <th className="p-2 border">Received</th>
              <th className="p-2 border">Resolved</th>
              <th className="p-2 border">Pending</th>
            </tr>
          </thead>
          <tbody>
            {annual.data.map((item, index) => (
              <tr key={index} className="text-sm md:text-base even:bg-gray-100">
                <td className="p-2 border">{item.Year}</td>
                <td className="p-2 border">{item.Carried_forward}</td>
                <td className="p-2 border">{item.Received}</td>
                <td className="p-2 border">{item.Resolved}</td>
                <td className="p-2 border">{item.Pending}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default Complaints;
